export default __webpack_public_path__ + "static/media/shifts_ic.d884e26c.svg";